import common from "../../../utils/common";
import c from "../../../utils/constants";

class userInvoicesController {
  constructor(UsersService, AppContextService, NotificationService) {
    "ngInject"

    this.usersService = UsersService;
    this.appContextService = AppContextService;
    this.notificationService = NotificationService;
  }

  $onInit() {
    const paidInvoices = this.user.invoices.filter(i => i.paid);
    var ctr = this;
    this.gridOptions = {
      dataSource: paidInvoices,
      sortable: true,
      pageable: false,
      resizable: true,
      noRecords: {
        template: "No Invoices."
      },
      columns: [
        { field: "date", title: "Date", filterable: false, width: "4rem", template: `#= kendo.toString(new Date(date), 'dd-MM-yyyy') #` },
        { field: "description", title: "Description", filterable: false, width: "8rem" },
        // { field: "subtotal", title: "Subtotal", filterable: false, width: "4rem", template: `#= '$' + (subtotal/100).toFixed(2) #` },
        // { field: "taxPercent", title: "Tax Percent", filterable: false, width: "4rem" },
        // { field: "tax", title: "Tax", filterable: false, width: "4rem", template: `#= '$' + (tax/100).toFixed(2) #` },
        // { field: "total", title: "Total", filterable: false, width: "4rem", template: `#= '$' + ((adjustedTotal - amountRefunded)/100).toFixed(2) #` },
        { field: "total", title: "Total", filterable: false, width: "4rem", template: `#= '$' + ((adjustedTotal)/100).toFixed(2) #` },
        { field: "refunded", title: "Refunded", filterable: false, width: "4rem", template: `#= '$' + ((amountRefunded)/100).toFixed(2) #` },
      ]
    };

    if (this.hasPaymentsAdminAccess()) {
      this.gridOptions.columns.push(
        {
          title: "Refund",
          command: [
            {
              click: function (e) {ctr.refundInvoice(this, e, ctr)},
              // Doesn't work with the current Kendo release.
              visible: function(dataItem) {
                return false;
              },
              text: "Refund"
            }],
            width: "4rem"
        }
      );
    }
  }

  hasPaymentsAdminAccess() {
    const appContext = this.appContextService.getAppContext();
    if (!appContext)
      return false;

    if (this.appContextService.hasPaymentsAdminAccess(appContext.roles))
      return true;
    else
      return false;
  }

  hasGlobalAdminAccess() {
    const appContext = this.appContextService.getAppContext();
    if (!appContext)
      return false;

    if (this.appContextService.hasGlobalAdminAccess(appContext.roles))
      return true;
    else
      return false;
  }

  refundInvoice(context, args, ctrl) {
    var tr = $(args.target).closest("tr");
    var invoice = context.dataItem(tr);

    if (!this.hasGlobalAdminAccess()) {
      const rawInvoice = this.user.invoices.find(i => i.id == invoice.id);
      const invoiceIdx = this.user.invoices.indexOf(rawInvoice);
      if (invoiceIdx != this.user.invoices.length - 1) {
        alert('Only the most recent invoice can be refunded.');
        return;
      }
    }

    if (invoice.amountRefunded > 0) {
      alert('This invoice has already been refunded.');
      return;
    }

    if (confirm('Are you sure you want to refund this invoice?')) {
      ctrl.usersService.refundInvoice(
        invoice.id,
        invoice,
        (response) => {
          ctrl.notificationService.success("Update Successful");
          ctrl.user = response.data;

          var dataSource = new kendo.data.DataSource({
            data: ctrl.user.invoices
          });
          var grid = $("#invoices-grid").data("kendoGrid");
          grid.setDataSource(dataSource);
        },
        (error) => {
          ctrl.notificationService.error(error.data ? error.data : "Update Failed");
        });
    }
  }

}

export default userInvoicesController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-invoices/user-invoices.controller.js
 **/